export default "__VITE_ASSET__h7Q5X3c6__"